import PropTypes from 'prop-types'
import { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Page from '@/components/Page'
import { fetchUsersPaginated } from '@/store/actions'
import {
  getCurrentOrganization,
  getCurrentUser,
  getSpaces,
  isRequestComplete,
  isRequestPending
} from '@/store/selectors'

import {
  addOrganizationAdmin,
  changeDefaultSpace,
  fetchOrganizationAdmins,
  removeOrganizationAdmin,
  updateOrganization
} from './actions'
import {
  ADD_ORGANIZATION_ADMIN,
  CHANGE_DEFAULT_SPACE,
  FETCH_ORG_USERS_TO_ADD,
  FETCH_ORGANIZATION_ADMINS,
  REMOVE_ORGANIZATION_ADMIN,
  UPDATE_ORGANIZATION
} from './actionTypes'
import messages from './messages'
import OrganizationAdmins from './OrganizationAdmins'
import OrganizationOverview from './OrganizationOverview'
import { getOrganizationAdmins, getSearchedUsersNotAlreadyAdmins } from './selectors'

const errorsToHandle = [
  {
    type: ADD_ORGANIZATION_ADMIN,
    data: { detailCode: 'OSPAOA' }
  },
  {
    type: REMOVE_ORGANIZATION_ADMIN,
    data: { detailCode: 'OSPROA' }
  }
]

class OrganizationSettingsPage extends Component<any, any> {
  static displayName = 'OrganizationSettingsPage'

  static propTypes = {
    actions: PropTypes.shape({
      addOrganizationAdmin: PropTypes.func.isRequired,
      changeDefaultSpace: PropTypes.func.isRequired,
      fetchOrganizationAdmins: PropTypes.func.isRequired,
      removeOrganizationAdmin: PropTypes.func.isRequired,
      updateOrganization: PropTypes.func.isRequired
    }).isRequired,
    currentUser: PropTypes.object.isRequired,
    isActionInProgress: PropTypes.bool,
    isAddingOrganizationAdmin: PropTypes.bool.isRequired,
    isRemovingOrganizationAdmin: PropTypes.bool.isRequired,
    isFetchingAdmins: PropTypes.bool.isRequired,
    isSearchUsersComplete: PropTypes.bool.isRequired,
    isSearching: PropTypes.bool.isRequired,
    searchResults: PropTypes.arrayOf(PropTypes.object),
    organization: PropTypes.object.isRequired,
    spaces: PropTypes.array.isRequired
  }

  static defaultProps = {
    isActionInProgress: false,
    searchResults: null,
    organizationAdmins: []
  }

  componentDidMount() {
    this.loadOrganizationAdmins()
  }

  loadOrganizationAdmins = () => {
    this.props.actions.fetchOrganizationAdmins()
  }

  changeSpace = (id: any) => {
    this.props.actions.changeDefaultSpace(id)
  }

  render() {
    const { isActionInProgress, organization, spaces, actions } = this.props

    return (
      <Page errorsToHandle={errorsToHandle}>
        <Page.Header title={<FormattedMessage {...messages.title} />} />
        <OrganizationOverview
          isActionInProgress={isActionInProgress}
          organization={organization}
          spaces={spaces}
          onSaveDefaultSpace={this.changeSpace}
          onSaveOrganization={actions.updateOrganization}
        />
        <OrganizationAdmins
          addOrganizationAdmin={this.props.actions.addOrganizationAdmin}
          currentUser={this.props.currentUser}
          fetchUsersPaginated={this.props.actions.fetchUsersPaginated}
          isSearching={this.props.isSearching}
          isFetchingAdmins={this.props.isFetchingAdmins}
          isAddingOrganizationAdmin={this.props.isAddingOrganizationAdmin}
          isRemovingOrganizationAdmin={this.props.isRemovingOrganizationAdmin}
          isSearchUsersComplete={this.props.isSearchUsersComplete}
          organizationAdmins={this.props.organizationAdmins}
          removeOrganizationAdmin={this.props.actions.removeOrganizationAdmin}
          searchResults={this.props.searchResults}
        />
      </Page>
    )
  }
}

export { /** @deprecated */ OrganizationSettingsPage }

function mapStateToProps(state: any) {
  return {
    currentUser: getCurrentUser(state),
    isActionInProgress: isRequestPending(state, [CHANGE_DEFAULT_SPACE, UPDATE_ORGANIZATION]),
    isAddingOrganizationAdmin: isRequestPending(state, [ADD_ORGANIZATION_ADMIN]),
    isFetchingAdmins: isRequestPending(state, FETCH_ORGANIZATION_ADMINS),
    isRemovingOrganizationAdmin: isRequestPending(state, REMOVE_ORGANIZATION_ADMIN),
    isSearchUsersComplete: isRequestComplete(state, FETCH_ORG_USERS_TO_ADD),
    isSearching: isRequestPending(state, FETCH_ORG_USERS_TO_ADD),
    organization: getCurrentOrganization(state),
    organizationAdmins: getOrganizationAdmins(state),
    searchResults: getSearchedUsersNotAlreadyAdmins(state),
    spaces: getSpaces(state)
  }
}

function mapDispatchToProps(dispatch: any) {
  return {
    actions: bindActionCreators(
      {
        addOrganizationAdmin,
        changeDefaultSpace,
        fetchUsersPaginated,
        fetchOrganizationAdmins,
        removeOrganizationAdmin,
        updateOrganization
      },
      dispatch
    )
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(OrganizationSettingsPage)
